module.exports = __webpack_public_path__ + "static/college_of_eloquence-4606e310d9bab168660a39bd24256a58.png";